import { useContext } from "react";
import { AccountsContext, AccountsContextI } from "@/context/accounts";

export const useAccountsContext = (): AccountsContextI =>
  useContext(AccountsContext);
